import axios from "axios";

export const getSignedUrlForZip = (fileData, dealerID, userID, token) => {
  return axios.post(`${process.env.REACT_APP_DEALER_API_GATEWAY_URL}get-signedurl`,
    { fileType: fileData?.type, dealerID, userID }, { headers: { Authorization: `Bearer ${token}` }, },
  );
};
